import React, { Component } from 'react'
import { DatePicker, List, Button, InputItem } from 'antd-mobile';
import '../../src/assects/css/Demo.css'
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);
class Demo extends Component {
    constructor(props){
        super(props);
        this.state={
            date: now,
            time: now
        }
    }
   
  render() {
    return (
      <div>
      <DatePicker
          mode="datetime"
          minuteStep={2}
          use12Hours
          format='YYYY-MM-DD'
          className="data-filt"
          value={this.state.time}
          onChange={time => this.setState({ time })}
          onOk={time => console.log(time)}
        >
          <List.Item arrow="horizontal">Time (am/pm)</List.Item>
        </DatePicker>
      </div>
    )
  }
}

export default Demo